import select from 'dom-select';
import Splide from '@splidejs/splide';
import 'lite-youtube-embed';

const Splider = (el) => {
  // Cache DOM selections once
  const ui = {
    el,
    labels: select.all('.figure__label', el),
    iframes: select.all('iframe', el),
    videos: select.all('video', el),
    youtubes: select.all('lite-youtube', el),
    carousel: select('.js-carousel', el),
    carouselNav: select('.js-carousel-nav', el),
    videoHighlight: select('.splide--highlight', el),
    marqueeBg: select('.js-carousel-marquee', el),
  };

  // Set defaults once, outside the function
  Splide.defaults = {
    arrows: true,
    autoplay: true,
    autoHeight: true,
    gap: '2.5rem',
    keyboard: true,
    pagination: false,
    padding: '2.5rem',
    rewind: true,
    speed: 1000,
    type: 'slide',
    updateOnMove: true,
  };

  // Carousel configuration options
  const carouselOptions = {
    thumbnails: {
      arrows: true,
      fixedWidth: '8.35rem',
      isNavigation: true,
      breakpoints: {
        834: {
          fixedWidth: '5.75rem',
        },
      },
    },
    videoHighlight: {
      arrows: true,
      padding: '5rem',
      pagination: false,
      rewind: true,
      speed: 1,
      type: 'slide',
      breakpoints: {
        833: {
          padding: '2rem',
        },
      },
    },
    marqueeBg: {
      autoplay: true,
      arrows: false,
      pauseOnHover: true,
      rewind: true,
      speed: 700,
      type: 'fade',
    },
  };

  const pauseVideos = () => {
    // Pause HTML5 videos
    ui.videos?.forEach(video => video.pause());

    // Pause YouTube embeds
    if (ui.youtubes) {
      const activeVideo = select('lite-youtube.lyt-activated');
      
      if (activeVideo) {
        activeVideo.getYTPlayer().then(player => {
          if (player.getPlayerState() === 1) {
            player.pauseVideo();
          }
        }).catch(() => {});
      }
    }

    // Reset iframes (reloads them)
    ui.iframes?.forEach(iframe => {
      iframe.src = iframe.src; // eslint-disable-line no-self-assign
    });
  };

  const setLabels = () => {
    const labelCount = ui.labels.length;
    ui.labels.forEach((label, index) => {
      label.textContent = `${index + 1} of ${labelCount}`;
    });
  };

  const initCarousels = () => {
    // Main carousel
    if (ui.carousel) {
      const carousel = new Splide(ui.carousel);
      carousel.mount();
      carousel.on('move', pauseVideos);

      // Thumbnail navigation
      if (ui.carouselNav) {
        const carouselNav = new Splide(ui.carouselNav, carouselOptions.thumbnails);
        carouselNav.mount();
        carousel.sync(carouselNav);
      }
    }

    // Video highlight carousel
    if (ui.videoHighlight) {
      const videoHighlight = new Splide(ui.videoHighlight, carouselOptions.videoHighlight);
      videoHighlight.mount();
      videoHighlight.on('move', pauseVideos);

      // Thumbnail navigation
      if (ui.carouselNav) {
        const carouselNav = new Splide(ui.carouselNav, carouselOptions.thumbnails);
        carouselNav.mount();
        videoHighlight.sync(carouselNav);
      }
    }

    // Marquee background carousel
    if (ui.marqueeBg) {
      const marqueeBg = new Splide(ui.marqueeBg, carouselOptions.marqueeBg);
      marqueeBg.mount();
    }
  };

  const init = () => {
    setLabels();
    initCarousels();
  };

  init();
};

export default Splider;